<template>
  <div id="app" @click='resetTimer()' @mousemove='resetTimer()'>
  	<heading></heading>
    <router-view/>
  </div>
</template>
<script>
	import Header from './components/Header.vue';

	export default {
	  name: 'app',
	  components: {
	  	'heading': Header
	  },
	  data(){
	  	return {
	      cover: true,
	      timeout: 0,
	  	}
	  },
	  created() {
	    this.removeCover();
	    this.startTimer();
	  },
	  methods: {
	    removeCover(){
	      let vm = this;
	      setTimeout(function(){
	        vm.cover = false;
	      }, 100);
	    },
	    resetTimer() {
	      let vm = this;
	      window.clearTimeout(vm.timeout);
	      this.startTimer();
	    },
	    startTimer(){
	      clearTimeout(this.timeout);
	      this.timeout = 0;
	      let vm = this;
	      this.timeout = window.setTimeout(
	          function() {
	              setTimeout(function(){
	                  if (vm.$route.name != 'Home') {
	                      vm.$router.push({ name: 'Home' });
	                  }else {
	                      window.location.reload();
	                  }
	          }, 500);
	      }, 710000);
	    },
	  },
	  watch: {
	    $route(to, from) {
	      this.removeCover();
	    }
	  }
	}
</script>
<style src='../public/css/main.css'></style>

